import { useState } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { FaBars, FaTimes, FaRoad } from "react-icons/fa";
import { logoutUser } from "../store/authSlice";

const navLinkClass = ({ isActive }) =>
  `block py-2 md:py-0 md:px-3 transition-colors ${
    isActive ? "text-amber-400" : "text-white/90 hover:text-amber-400"
  }`;

const Navbar = () => {
  const [open, setOpen] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { token, user } = useSelector((state) => state.auth);
  const isLoggedIn = Boolean(token);

  const handleLogout = () => {
    dispatch(logoutUser());
    setOpen(false);
    navigate("/");
  };

  return (
    <header className="sticky top-0 z-50 border-b border-white/10 bg-navy-900/95 backdrop-blur-md">
      <div className="mx-auto flex max-w-6xl items-center justify-between px-4 py-3 lg:px-6">
        <Link to="/" className="group flex items-center gap-2.5">
          <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-amber-500 text-navy-950 shadow-[0_0_0_4px_rgba(245,158,11,0.18)] transition group-hover:scale-105">
            <FaRoad className="text-lg" />
          </span>
          <span className="font-display text-xl font-bold tracking-tight text-white">
            Fix<span className="text-amber-400">My</span>Road
          </span>
        </Link>

        <button
          type="button"
          className="rounded-lg p-2 text-white md:hidden"
          onClick={() => setOpen((v) => !v)}
          aria-label="Toggle menu"
        >
          {open ? <FaTimes /> : <FaBars />}
        </button>

        <nav
          className={`${
            open ? "flex" : "hidden"
          } absolute left-0 right-0 top-full z-50 max-h-[70vh] flex-col gap-1 overflow-y-auto border-b border-white/10 bg-navy-900 px-4 py-4 shadow-xl md:static md:max-h-none md:flex md:flex-row md:items-center md:gap-1 md:overflow-visible md:border-0 md:bg-transparent md:p-0 md:shadow-none`}
        >
          <NavLink to="/" end className={navLinkClass} onClick={() => setOpen(false)}>
            Home
          </NavLink>
          <NavLink to="/about" className={navLinkClass} onClick={() => setOpen(false)}>
            About
          </NavLink>
          <NavLink to="/report" className={navLinkClass} onClick={() => setOpen(false)}>
            Report
          </NavLink>
          <NavLink to="/potholes" className={navLinkClass} onClick={() => setOpen(false)}>
            Potholes
          </NavLink>
          <NavLink to="/feedback" className={navLinkClass} onClick={() => setOpen(false)}>
            Feedback
          </NavLink>
          <NavLink to="/contact" className={navLinkClass} onClick={() => setOpen(false)}>
            Contact
          </NavLink>

          {isLoggedIn ? (
            <>
              <NavLink
                to="/dashboard"
                className={navLinkClass}
                onClick={() => setOpen(false)}
              >
                Dashboard
              </NavLink>
              <div className="mt-2 flex items-center gap-3 md:mt-0 md:ml-3">
                <span className="hidden text-sm text-white/70 lg:inline">
                  {user?.name?.split(" ")[0] || "User"}
                </span>
                <button
                  type="button"
                  onClick={handleLogout}
                  className="rounded-lg bg-white/10 px-4 py-2 text-sm font-medium text-white transition hover:bg-white/20"
                >
                  Logout
                </button>
              </div>
            </>
          ) : (
            <Link
              to="/login"
              onClick={() => setOpen(false)}
              className="mt-2 rounded-lg bg-amber-500 px-4 py-2 text-center text-sm font-semibold text-navy-950 transition hover:bg-amber-400 md:mt-0 md:ml-3"
            >
              Login
            </Link>
          )}
        </nav>
      </div>
    </header>
  );
};

export default Navbar;
